import { ca } from '@cian/analytics';

export function trackAdviceLinkClick() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'AnalisysOnline',
    action: 'GoTo',
    label: 'GetAnalystAdvice',
  });
}
